import { useSelector } from 'react-redux';

import Slider from '@swf/components/Slider/Slider';
import type { RootState } from '@swf/core/store';

import { usePokerMultiTableTournamentsWidget } from '../../model';

import HighlightsItem from './HighlightsItem/HighlightsItem';
import styles from './HighlightsSection.scss';

const HighlightsSection = () => {
  const { widgetConfig, widgetSelect } = usePokerMultiTableTournamentsWidget();
  const highlightTournaments = useSelector((rootState: RootState) =>
    widgetSelect.getHighlightTournaments(rootState, widgetConfig)
  );

  if (highlightTournaments.length === 0) return null;

  return (
    <div className={styles.highlightSection}>
      <Slider innerClassName={styles.slider}>
        {highlightTournaments.map((tournament) => (
          <HighlightsItem key={tournament.id} tournament={tournament} />
        ))}
      </Slider>
    </div>
  );
};

export default HighlightsSection;
